import "../../utils/messages";
import { TFA_MESSAGES } from "../../utils/messages";
import qs from 'querystring';
import { ClientMessage } from "../../utils/objects";

export function assignTfaRequests(api) {
    /*************************************************TFA*********************************************************************/
    api.toggleTFA = async function () {
        var clientMessage = ClientMessage.success(TFA_MESSAGES.ENABLED);
        var response = await api.get('/accounts/auth/mfa', this.buildConfigTFA())
            .then(res => {
                console.log(res.headers['Cookie']);
                return res.data.auth_uri;
            })
            .catch(e => {
                clientMessage = this.checkError(e, TFA_MESSAGES.NOT_ENABLED);
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "TFAMethods");
        return response;
    }

    api.enableTFA = async function (code) {
        var clientMessage = ClientMessage.success(TFA_MESSAGES.ENABLED);

        var data = {
            'validation_totp': code,
        };

        var response = await api.post('/accounts/auth/mfa/enable', data, this.buildConfigTFA())
            .then(res => res.data)
            .catch(e => {
                clientMessage = this.checkError(e, TFA_MESSAGES.NOT_ENABLED);
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "TFAMethods");
        return response;
    }

    api.disableTFA = async function () {
        var clientMessage = ClientMessage.success(TFA_MESSAGES.DISABLED);

        var response = await api.get('/accounts/auth/mfa/disable', this.buildConfigTFA())
            .then(res => {
                console.debug(res);
                return true;
            })
            .catch(e => {
                clientMessage = this.checkError(e, TFA_MESSAGES.NOT_DISABLED);
                return false;
            });
        this.emitFunction("sendClientMessage", clientMessage, "TFAMethods");

        return response;
    }

    api.confirmTFA = async function (TFACode) {
        var config = this.buildConfig();
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        var response = await api.post(
            '/accounts/auth/options/mfa',
            qs.stringify({ Code: TFACode }),
            config
        ).then(res => res.data)
            .catch(e => {
                this.checkError(e);
                return null;
            });

        return response;
    }

    api.getLocalPublicIP = async function () {
        var response = await api.get("https://api.ipify.org?format=json")
            .then(res => res.data.ip)
            .catch(e => {
                console.writeError(e);
                return null;
            });

        return response;
        /*$.getJSON("https://api.ipify.org?format=json",
            function(data) {
     
                    // Displayin IP address on screen
                alert(data.ip);
        });*/
    }
    //}
}
